import { useAppSelector } from '~/hooks/useAppSelector';
import { hasChildOffices } from '~/utils/OfficeUtils';

/**
 * Hook to check if an office is the parent of a multi-location account.
 * Returns true when: the account has child offices AND the office is the signed-in parent.
 *
 * @param officeId - the office to ask about; the one selected in the header when omitted
 */
export const useIsParentOfficeSelector = (officeId?: string) => {
  const isParentOffice = useAppSelector(
    (state) =>
      hasChildOffices(state.user?.childOffices) &&
      (officeId ?? state.user?.selectedChildOffice?.id) === state.user?.user?.id,
  );

  return isParentOffice;
};
